module.exports = __webpack_public_path__ + "assets/icon-star-rating.79a23c09.svg";